export default __webpack_public_path__ + "static/media/image7.f2c68618.png";